import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import { mapState } from "vuex";
import wx from "weixin-js-sdk";
import uGlobalFun from "@/utils/uroadUtils/uGlobal.js";
export default {
  components: {
    [_Loading.name]: _Loading
  },
  computed: { ...mapState({
      loadingObj: state => state.loadingObj //是否显示loading1

    })
  },

  data() {
    return {};
  },

  created() {
    //上线关闭这个  打开下面的 获取openid
    // let obj = {
    //   openid: "oQSlT6i2ZshQZNyzIHGpd-nFuLJc",
    //   unionid: "ooKIAv-BbpCM-xymQUePWk2-CUj0",
    // };
    // localStorage.setItem("openId", JSON.stringify(obj));
    // sessionStorage.setItem(
    //   "token",
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJ1cm9hZCIsImlhdCI6MTcwMTkxMjgxNSwiZXhwIjoxNzAxOTIwMDE1LCJuYmYiOjE3MDE5MTI4MTUsInN1YiI6InVzZXIiLCJhdWQiOiI4IiwianRpIjoiODE3MDE5MTI4MTUifQ.BR1RTC4eBMSt49dCytClNaLjrf_zzgmvVPnHz0LwKZ0"
    // );
    // return
    let code = this.GetQueryString("code") || window.sessionStorage.getItem("code");
    const local = window.location.href;
    console.log(local);

    if (code == null || code === "") {
      // encodeURIComponent("https://etc.scjtonline.cn/ScWeChatAvatar/")
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + "wx8d15bced561d53a7" + "&redirect_uri=" + encodeURIComponent(local) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    } else {
      window.sessionStorage.setItem("code", code);
      console.log("打印出的code", code);
      uGlobalFun.$Post("/OpenApi/WeChat/getUser", {
        code: code,
        url: "https://etc.scjtonline.cn/sandbox/SCTravelservices_CS",
        isApi: true
      }, res => {
        console.log("res-wx", res);

        if (res.code == 0) {
          const jsapiData = res.data.jsapi_ticket;
          const userInfo = {
            nickName: res.data.nickname,
            unionid: res.data.unionid
          };
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          wx.config({
            debug: false,
            appId: "wx8d15bced561d53a7",
            timestamp: jsapiData.timestamp,
            nonceStr: jsapiData.nonceStr,
            signature: jsapiData.signature,
            jsApiList: ["chooseImage", "previewImage"],
            openTagList: ["wx-open-launch-weapp"]
          });
          let leftUrl = "";
          let rightUrlArr = "";
          let queryObj = {};

          if (local.indexOf("/?" > -1)) {
            const urlArr = local.split("/?");
            leftUrl = urlArr[0] + "/#/";
            rightUrlArr = urlArr[1].split("#/"); // 获取code和state参数

            rightUrlArr[0].split("&").map(item => {
              const splitStr = item.split("=");
              return {
                key: splitStr[0],
                value: splitStr[1]
              };
            }).forEach(item => {
              queryObj[item.key] = item.value;
            });
            location.href = `${leftUrl}${rightUrlArr[1]}?code=${decodeURIComponent(queryObj.code)}`;
          }
        }

        wx.ready(() => {
          console.log("微信配置成功");
        });
      }, err => {
        console.log("err", err);
      }, false);
    }
  },

  methods: {
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }

  }
};